export default "__VITE_ASSET__BnRHaKT9__"